import {Component, Inject, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Company} from 'src/app/model/company';
import {AuthService} from 'src/app/services/auth.service';
import {CompaniesService} from 'src/app/services/companies.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'aw-add-dependecies-test-image',
  templateUrl: './add-dependecies-test-image.component.html',
  styleUrls: ['./add-dependecies-test-image.component.scss']
})
export class AddDependeciesTestImageComponent implements OnInit {

  company?: Company;
  dependencies: any[];
  isNoDependeciesDefinedSelected = false;
  isNoDependeciesRequiredSelected = false;
  dependenciesForm = new FormControl<string[] | undefined>([]);
  completeSubmission: any;

  constructor (
    public dialogRef: MatDialogRef<AddDependeciesTestImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public companyService: CompaniesService,
    private snackbar: MatSnackBar,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.company = this.data.company;
    this.companyService.getSubmissionInformation(this.company.id).subscribe(response => {
      let res = response as any;
      this.dependencies = res.data['dependency-list'];
    });
  }

  onSelectionDependeciesChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('No dependencies required')) {
      this.isNoDependeciesRequiredSelected = true;
      this.isNoDependeciesDefinedSelected = false;
      this.dependenciesForm.setValue(['No dependencies required']);
    }
    else if (selectedValues.includes('No dependencies already defined')) {
      this.isNoDependeciesRequiredSelected = false;
      this.isNoDependeciesDefinedSelected = true;
      this.dependenciesForm.setValue(['No dependencies already defined']);
    }
    else {
      this.isNoDependeciesRequiredSelected = false;
      this.isNoDependeciesDefinedSelected = false;
      this.dependenciesForm.setValue(selectedValues);
    }

  }

  onDependenciesSubmit() {

    let finalSubmission = {
      testid: this.data.testid,
      scriptName: this.data.scriptName,
      dependencies2add: this.dependenciesForm.value
    };

    if (finalSubmission.dependencies2add[0] === 'No dependencies required')
      finalSubmission.dependencies2add = [];
    if (finalSubmission.dependencies2add[0] === 'No dependencies already defined')
      finalSubmission.dependencies2add = ["NOT_AVAILABLE"];

    this.companyService.addDependeciesTestImage(this.company.id, finalSubmission).subscribe(response => {
        this.snackbar.open("Depedency added correctly!", 'Ok', {
            duration: 2000
          });
        this.dialogRef?.close({ success: true });
      }, error => {
          this.snackbar.open("Dependecy NOT added correctly!", 'Ok', {
            duration: 2000
          });
    })

  }

}
